<template>
  <div class="container">
    <van-nav-bar title="首页" />
    <!-- <van-icon name="search" class="searchIcon"/> -->
    <van-search
      label=""
      shape="round"
      background="none"
      placeholder="请输入充值订单编号、退款单号、手机号码、设备编号"
      @click="changePage('searchAll')"
      disabled
    >
    </van-search>

    <div class="main">
      <div class="msgBox">
        <div class="title blod">
          <span class="topline"></span>
          <span>整体数据</span>
        </div>
        <div class="flex">
          <div class="item">
            <div class="lab">营收总额</div>
            <div class="val col_o">￥{{dataObj.revenueTotalAmount || "--"}}</div>
          </div>
          <div class="fg"></div>
          <div class="item">
            <div class="lab">在管项目</div>
            <div class="val">{{dataObj.communityCount || "--"}}</div>
          </div>
          <div class="fg"></div>
          <div class="item">
            <div class="lab">总用户数</div>
            <div class="val">{{dataObj.servicePersonCount || "--"}}</div>
          </div>
          <div class="fg"></div>
          <div class="item">
            <div class="lab">充电电量</div>
            <div class="val">{{dataObj.charingElecCount || "--"}}</div>
          </div>
        </div>
      </div>
      <div class="msgBox">
        <div class="title blod">
          <span class="topline"></span>
          <span>今日数据</span>
        </div>
        <div class="flex">
          <div class="item">
            <div class="lab">今日充值</div>
            <div class="val col_o">￥{{todayDataObj.todayRechargeAmounts || "--"}}</div>
            <div class="msg">
              <span>较昨日</span>
              <span class="col_o" v-if="todayDataObj.rechargeScale>0">+{{todayDataObj.rechargeScale || "--"}}%</span>
              <span class="col_g" v-else>{{todayDataObj.rechargeScale || "--"}}%</span>
            </div>
          </div>
          <div class="fg2"></div>
          <div class="item">
            <div class="lab">今日退款</div>
            <div class="val">￥{{todayDataObj.todayRefundAmounts || "--"}}</div>
            <div class="msg">
              <span>较昨日</span>
              <span class="col_o" v-if="todayDataObj.refundScale>0">+{{todayDataObj.refundScale || "--"}}%</span>
              <span class="col_g" v-else>{{todayDataObj.refundScale || "--"}}%</span>
            </div>
          </div>
          <div class="fg2"></div>
          <div class="item">
            <div class="lab">充电消费</div>
            <div class="val">￥{{todayDataObj.todayChargeAmounts || "--"}}</div>
            <div class="msg">
              <span>较昨日</span>
              <span class="col_o" v-if="todayDataObj.chargeScale>0">+{{todayDataObj.chargeScale || "--"}}%</span>
              <span class="col_g" v-else>{{todayDataObj.chargeScale || "--"}}%</span>
            </div>
          </div>
          <div class="fg2"></div>
          <div class="item">
            <div class="lab">充电用户</div>
            <div class="val">{{todayDataObj.todayChargeUsers || "--"}}</div>
            <div class="msg">
              <span>较昨日</span>
              <span class="col_o" v-if="todayDataObj.chargeUserScale>0">+{{todayDataObj.chargeUserScale || "--"}}%</span>
              <span class="col_g" v-else>{{todayDataObj.chargeUserScale || "--"}}%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="topNotice" v-if="noticeList.length > 0">
        <van-notice-bar left-icon="volume-o" color="#1989fa" background="#ecf9ff">
          <span @click="goNoticeDetail(item)" class="spanItem" :key="index" v-for="(item,index) in noticeList">{{item.title}}</span>
        </van-notice-bar>
      </div>

      <div class="flex">
        <div class="devicebox" @click="changeUrl(4)">
          <div class="lab">待激活设备数</div>
          <div class="val">{{dataObj.deviceNoActivedCount || 0}}</div>
        </div>
        <div class="devicebox" @click="changeUrl(3)">
          <div class="lab">故障设备数</div>
          <div class="val">{{dataObj.deviceErrorCount || 0}}</div>
        </div>
      </div>

      <div class="menu-box">
        <div class="menu-item" @click="changePage('projectList')">
          <div class="">
            <img src="../assets/img/menu1.png" alt="">
          </div>
          <div class="lab">在管项目</div>
        </div>
        <div class="menu-item" @click="changePage('deviceList')">
          <div>
            <img src="../assets/img/menu2.png" alt="">
          </div>
          <div class="lab">管理设备</div>
        </div>
        <div class="clearfix menu-item" @click="scanQRCode()">
          <div>
            <img src="../assets/img/menu3.png" alt="">
          </div>
          <div class="lab">设备激活</div>
        </div>
        <div class="menu-item" @click="changePage('warn')">
          <div>
            <van-badge v-if="dataObj.noreadWarningCount > 0" :content="dataObj.noreadWarningCount" max="99">
              <img src="../assets/img/menu4.png" alt="">
            </van-badge>
            <img v-else src="../assets/img/menu4.png" alt="">
          </div>
          <div class="lab">告警通知</div>
        </div>
        <div class="menu-item" @click="changePage('rechargeList')">
          <div >
            <img src="../assets/img/menu5.png" alt="">
          </div>
          <div class="lab">充值记录</div>
        </div>
        <div class="menu-item" @click="changePage('refundList')">
          <div >
            <img src="../assets/img/menu6.png" alt="">
          </div>
          <div class="lab">退款记录</div>
        </div>
        <div class="menu-item" @click="changePage('chargeList')">
          <div >
            <img src="../assets/img/menu7.png" alt="">
          </div>
          <div class="lab">充电记录</div>
        </div>
        
        <div class="menu-item" @click="changePage('statistics')">
          <div>
            <img src="../assets/img/menu8.png" alt="">
          </div>
          <div class="lab">统计分析</div>
        </div>
        
        <div class="menu-item" @click="changePage('meterList')">
          <div>
            <img src="../assets/img/menu9.png" alt="">
          </div>
          <div class="lab">抄表管理</div>
        </div>
        <div class="menu-item" @click="changePage('khList')" v-if="userInfo.type == 1">
          <div>
            <img src="../assets/img/menu11.png" alt="">
          </div>
          <div class="lab">客户留资</div>
        </div>
        <div class="menu-item" @click="changePage('changephone')">
          <div>
            <img src="../assets/img/menu12.png" alt="">
          </div>
          <div class="lab">余额转移</div>
        </div>
        <div class="menu-item" @click="changePage('historyChargeList')">
          <div>
            <img src="../assets/img/menu13.png" alt="">
          </div>
          <div class="lab">历史充电</div>
        </div>
        <div class="menu-item" @click="changePage('cardManageList')">
          <div>
            <img src="../assets/img/menu14.png" alt="">
          </div>
          <div class="lab">卡片管理</div>
        </div>
        <div class="menu-item" @click="changePage('constructionList')">
          <div>
            <img src="../assets/img/menu15.png" alt="">
          </div>
          <div class="lab">施工管理</div>
        </div>
        <div class="menu-item" @click="changePage('virtualRecharge')"  v-if="userInfo.type == 1">
          <div>
            <img src="../assets/img/menu16.png" alt="">
          </div>
          <div class="lab">虚拟充值</div>
        </div>
      </div>
    </div>

    
    <van-tabbar v-model="active">
      <van-tabbar-item>
        <template>
          <img class="nav-img" src="../assets/img/nav1_h.png" />
        </template>
        <div class="col_b">首页</div>
      </van-tabbar-item>
      <van-tabbar-item @click="changePage('warn')">
        <template>
          <van-badge v-if="dataObj.noreadWarningCount>0" :content="dataObj.noreadWarningCount" max="99">
            <img class="nav-img" src="../assets/img/nav2.png" />
          </van-badge>
          <img v-else class="nav-img" src="../assets/img/nav2.png" />
        </template>
        <div class="">告警</div>
      </van-tabbar-item>
      <van-tabbar-item @click="changePage('mine')">
        <template>
          <img class="nav-img" src="../assets/img/nav3.png" />
        </template>
        <div class="">我的</div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import Vue from 'vue';
  import {saveToLocal,loadFromLocal} from '../localStorage';
  import {NavBar,Icon,Grid,GridItem,Image,Swipe,SwipeItem,Toast,Loading,Popup,Tabbar,TabbarItem,Badge,NoticeBar,search} from 'vant';
  export default {
    data() {
      return {
        active: 0,
        dataObj:{},
        userInfo:{},
        todayDataObj:{},
        noticeList:[],
        imgDomain:'https://soonsmart.keji.io/',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Grid.name]:Grid,
      [GridItem.name]:GridItem,
      [Image.name]:Image,
      [Swipe.name]:Swipe,
      [SwipeItem.name]:SwipeItem,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,  
      [Popup.name]:Popup,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [Badge.name]:Badge,
      [NoticeBar.name]:NoticeBar,
      [search.name]:search,
    },
    methods: {
      getUserInfo() {
        axios.get("/auth/getuserinfo",{
        }).then((res)=>{
          this.userInfo = res.data;
        })
      },
      unOpen(){
        Toast('程序猿正在加班对接中');
      },
      changePage(url){
        if(url == 'warn'){
          if(this.dataObj.noreadWarningCount == 1){
            //只有一条告警时 跳转到详情页
            this.$router.push({path: "warnDetail.html",query:{rowId:this.dataObj.warningId}});
          }else{
            this.$router.push({path: url+".html"});
          }
        }else{
          this.$router.push({path: url+".html"});
        }
        
      },
      goSearch(){
        this.$router.push({path: "searchAll.html",query:{isDetail:1}})
      },
      changeUrl(tab_active){
        this.$router.push({path: "deviceList.html",query:{tab_active:tab_active}});
      },
      goNoticeDetail(item){
        if(item.contentType == 2){
          window.open(this.imgDomain+item.content);
        }else{
          this.$router.push({path: "helpDetail.html",query:{rowId:item.id}})
        }
      },
      //解析链接方法
      getQueryString(url, name) {
        var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i');
        var r = url.substr(1).match(reg);
        if (r != null) {
          return r[2];
        }
        return null;
      },
      scanQRCode(){
        var that = this;
        Vue.wechat.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let qrUrl = decodeURIComponent(result);
            let mainNo = that.getQueryString(qrUrl, 'mainNo');
            if(mainNo){
              that.$router.push({path: "qrInfo.html",query:{mainNo:mainNo}});
            }else{
              Toast('请扫描设备码');
            }
          }
        });
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      getDataObj() {
        //首页各个数据统计
        axios.get("/home/statisticsdata",{}).then((res)=>{
          this.dataObj = res.data;
        })
        axios.get("/home/todaydata",{}).then((res)=>{
          this.todayDataObj = res.data;
        })
      },
      getNoticeList() {
        //首页公告
        axios.get("/techsupport/gettop3noticelist?code=business-notice",{}).then((res)=>{
          this.noticeList = res.data;
        })
      },
    },
    computed:{
    },
    created () {
      this.getDataObj();
      this.getNoticeList();
      this.getUserInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;
    background: url(../assets/img/home_bg.png) no-repeat #F0F4F7;
    background-size: 100%;
    padding-bottom: 100px;
  }
  .main{
    padding: 0 6px;
  }
  .searchIcon{
    position: absolute;
    z-index: 99;
    right:15px;
    top: 10px;
    color:#E6A23C;
    font-size: 20px;
    font-weight: bold;
  }
  .msgBox{
    width: 100%;
    padding: 6px;
    background: #fff;
    box-shadow: 0px 2px 4px 2px rgba(154,187,184,0.16);
    border-radius: 6px;
    margin-bottom: 8px;
    .topline{
      width: 4px;
      height: 14px;
      margin: 2px 4px 0 0;
      vertical-align: top;
      display: inline-block;
      background: #78B0FF;
      border-radius: 2px;
    }
    .title{
      font-size: 14px;
      margin-bottom: 8px;
    }
    .item{
      // width: 24%;
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      .lab{
        font-size: 13px;
        color: #373737;
        margin-bottom: 4px;
      }
      .val{
        min-height: 20px;
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
        color: #373737;
      }
      .msg{
        font-size: 10px;
        color: #9A9A9A;
        margin-top: 4px;
      }
    }
    .fg{
      height: 16px;
      width: 1px;
      background: #D1D2D3;
      display: inline-block;
      margin-top: 14px;
    }
    .fg2{
      height: 24px;
      width: 1px;
      background: #D1D2D3;
      display: inline-block;
      margin-top: 20px;
    }
  }
  .devicebox{
    width: 45%;
    color: #fff;
    padding: 8px;
    box-sizing: border-box;
    .lab{font-size: 14px;}
    .val{
      font-size: 20px;
      padding: 8px 0 0 30px;
    }
  }
  .devicebox:nth-child(1){
    background: url(../assets/img/h_b1.png) no-repeat;
    background-size: 100% 100%;
  }
  .devicebox:nth-child(2){
    background: url(../assets/img/h_b2.png) no-repeat;
    background-size: 100% 100%;
  }

  .menu-box{
    padding-top: 16px;
    width: 100%;
    background: #fff;
    box-shadow: 0px 2px 4px 2px rgba(154,187,184,0.16);
    border-radius: 6px;
    margin-top: 8px;
    .menu-item{
      width: 25%;
      display: inline-block;
      text-align: center;
      margin-bottom: 8px; 
      font-size: 14px;
      img{
        width: 45px;
      }
      .lab{
        line-height: 30px;
        color: #373737;
      }
    }
  }
  .topNotice{
    width: 100%;
    margin-bottom: 8px;
  }
  
  .spanItem{
    display: inline-block;
    margin-right: 50px;
  }




  .van-nav-bar{background: none;}
  /deep/.van-nav-bar__title{font-weight: bold;}
  /deep/.van-hairline--bottom::after {
    border-bottom-width: 0px;
  }

  /deep/.van-search__content {
    background-color: #fff;
  }
  
  // *************************** 底部导航样式重置 ******************************
  .van-tabbar{
    padding: 8px 0 20px 0;
    border-radius: 14px 14px 0px 0px;
    overflow: hidden;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
  }
  /deep/.van-info{top: 5px; right: -6px;}
  .nav-img{width: 24px;margin-bottom: 4px;}
  .col_b{color: #2FAAFF;font-weight: bold;}
</style>
